export default __webpack_public_path__ + "static/media/videoIcon2.b37808d7.svg";